import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space } from 'antd';
import PropTypes from 'prop-types';
import { useRef, useEffect, useState } from 'react';

const TableColumnSearch = ({
  dataIndex,
  setSearchText,
  setSearchedColumn,
  handleReset,
  handleSearch,
  filtered,
}) => {
  const searchInput = useRef(null);
  const [inputValue, setInputValue] = useState(filtered || '');

  useEffect(() => {
    setInputValue(filtered || '');
  }, [filtered]);

  const onSearch = selectedKeys => {
    // Support both old and new handleSearch function signatures
    if (setSearchText && setSearchedColumn) {
      setSearchText(selectedKeys?.[0]);
      setSearchedColumn(dataIndex);
    }
    handleSearch(selectedKeys, dataIndex);
  };

  const onReset = clearFilters => {
    setInputValue('');
    // Support both old and new handleReset function signatures
    if (setSearchText) {
      setSearchText('');
    }
    handleReset(clearFilters);
  };

  return {
    filterDropdown: ({ setSelectedKeys, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={e => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={inputValue}
          onChange={e => {
            const value = e.target.value;
            setInputValue(value);
            setSelectedKeys(value ? [value] : []);
          }}
          onPressEnter={() => onSearch([inputValue])}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => onSearch([inputValue])}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => onReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button type="link" size="small" onClick={() => close()}>
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: () => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    filteredValue: filtered ? [filtered] : null,
  };
};

TableColumnSearch.propTypes = {
  setSearchedColumn: PropTypes.func,
  setSearchText: PropTypes.func,
  handleReset: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  dataIndex: PropTypes.string,
  filtered: PropTypes.string,
};

export default TableColumnSearch;
